// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separator{border-color:rgba(31,21,9,.05);border-top:1px rgba(31,21,9,.05);border-color:rgba(31,21,9,var(--tw-border-opacity));border-style:solid;--tw-border-opacity:0.05}.big.separator{height:10px;height:.75rem}.thin.separator{height:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
